// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"5748":"56ff9416","9330":"eeaaefc1"}[chunkId] + ".chunk.css");